
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import SupportSection from './components/SupportSection';
import ContactSection from './components/ContactSection';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Breadcrumb />
      <main>
        <HeroSection />
        <IntroSection />
        <ServicesSection />
        <ProcessSection />
        <SupportSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
